import { createAdminRepository } from "data/admin/repositoryFactory";
import {
  normalizeBooking,
  normalizeBusiness,
  normalizeDeal,
  normalizeProvince,
  normalizeSubscription,
  normalizeUserProfile,
} from "data/admin/domain";

const provincesBase = createAdminRepository({
  collectionName: "provinces",
  idPrefix: "province",
  getId: (item) => item.id,
  normalize: normalizeProvince,
});

const dealsBase = createAdminRepository({
  collectionName: "deals",
  idPrefix: "deal",
  getId: (item) => item.id,
  normalize: normalizeDeal,
});

const businessesBase = createAdminRepository({
  collectionName: "businesses",
  idPrefix: "business",
  getId: (item) => item.id,
  normalize: normalizeBusiness,
});

const bookingsBase = createAdminRepository({
  collectionName: "bookings",
  idPrefix: "booking",
  getId: (item) => item.id,
  normalize: normalizeBooking,
});

const subscriptionsBase = createAdminRepository({
  collectionName: "subscriptions",
  idPrefix: "subscription",
  getId: (item) => item.id || item.userId,
  normalize: normalizeSubscription,
});

const usersBase = createAdminRepository({
  collectionName: "users",
  idPrefix: "user",
  getId: (item) => item.uid || item.id,
  normalize: normalizeUserProfile,
});

export const adminRepositories = {
  provinces: {
    ...provincesBase,
  },
  deals: {
    ...dealsBase,
  },
  businesses: {
    ...businessesBase,
    list(params = {}) {
      return businessesBase.list({
        ...params,
        filter: (item) => {
          if (params.provinceId && item.location?.provinceId !== params.provinceId) return false;
          if (params.category && item.category !== params.category) return false;
          return true;
        },
      });
    },
    listByProvince(provinceId) {
      return this.list({ provinceId });
    },
  },
  bookings: {
    ...bookingsBase,
    listByBusinessId(businessId) {
      return bookingsBase.list({ filter: (item) => item.businessId === businessId });
    },
    updateStatus(id, status) {
      return bookingsBase.update(id, { status });
    },
  },
  subscriptions: {
    ...subscriptionsBase,
  },
  users: {
    ...usersBase,
  },
};